import { SWRFetcher } from '@commenda/utils';
import { useMemo } from 'react';
import useSWR, { KeyedMutator } from 'swr';
import { useApiScope } from '../scope';
import { IBankAccount } from './types';

function normalizeBankAccount(account: IBankAccount): IBankAccount {
  return account;
}

// You can either pass corporationId or the companyId. You can't pass both at the same time
export function useBankAccount({
  corporationId,
  token,
}: {
  corporationId: number;
  token?: string | undefined;
}) {
  const { shareToken } = useApiScope();

  const url = `bankAccount?corporationId=${corporationId?.toString()}`;

  const {
    data,
    error,
    mutate,
  }: {
    data?: { accounts: IBankAccount[] };
    error?: unknown;
    mutate: KeyedMutator<{ accounts: IBankAccount[] }>;
  } = useSWR(
    url,
    SWRFetcher(
      {
        method: 'GET',
        shareToken,
      },
      token
    )
  );

  // Memoize on the underlying SWR `data` reference so consumers that depend
  // on `normalizedData` (e.g. as a useEffect dep) don't see a new reference
  // every render — which would otherwise trigger infinite update loops in
  // any consumer doing `useEffect(() => setState(...), [bankAccounts])`.
  const normalizedData = useMemo(
    () =>
      data
        ? {
            ...data,
            accounts: data.accounts.map(normalizeBankAccount),
          }
        : undefined,
    [data]
  );

  return {
    data: normalizedData,
    error,
    mutate,
  };
}
